$( document ).ready(function() {

    $('.swiper-slide').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,

        dots: true,

        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1,

                }
              },
            {
                breakpoint: 1000,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,

                }
              },
            {
                breakpoint: 765,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },

        ]
      });

var windowWidth = $(window).width();
if (windowWidth <= 950) {
  $('img[data-small-src]').each(function() {
    var small_src = $(this).data('small-src');
    var slug_src = $(this).data('mobile-image-slug');
    if (slug_src != ""){
        $(this).attr('src', small_src);
    }
    console.log( $(this).data('small-src') );
  });
}
});

$( "#descargar-btn" ).click(function() {

    const element = document.querySelector('#menu-descargar');

    var windowWidth = $(window).width();
    if (windowWidth <= 950) {
        element.classList.add('mobile-1');
        element.classList.remove('d-none','animate__backOutUp');
        element.classList.add('animate__animated', 'animate__backInDown');
    }else{
        element.classList.remove('d-none','animate__backOutRight');
        element.classList.add('animate__animated', 'animate__backInRight');
    }
  });

  $( "#cerrar-descargar-btn" ).click(function() {
    var windowWidth = $(window).width();
    const element = document.querySelector('#menu-descargar');

    if (windowWidth <= 950) {
        element.classList.remove('animate__backInDown',);

       element.classList.add('animate__backOutUp');

    }else{
        element.classList.remove('animate__backInRight',);

        element.classList.add('animate__backOutRight');
    }
  });


  $( "#btn-show-indice" ).click(function() {

    const element = document.querySelector('#indice');
    var windowWidth = $(window).width();
    if (windowWidth <= 950) {
        element.classList.add('mobile-2');
        element.classList.remove('d-none','animate__backOutUp','d-sm-none', 'd-md-none');
        element.classList.add('animate__animated', 'animate__backInDown');
    }else{
        //element.classList.remove('d-none','animate__backOutRight');
        //element.classList.add('animate__animated', 'animate__backInRight');
    }
  });

  $( "#btn-close-indice" ).click(function() {
    var windowWidth = $(window).width();
    const element = document.querySelector('#indice');

    if (windowWidth <= 950) {
        element.classList.remove('animate__backInDown',);

       element.classList.add('animate__backOutUp');

    }else{
       // element.classList.remove('animate__backInRight',);

        //element.classList.add('animate__backOutRight');
    }

});


$( ".item-indice" ).click(function() {
    var windowWidth = $(window).width();
    const element = document.querySelector('#btn-close-indice');

    if (windowWidth <= 950) {
        $( element ).click();

    }else{
       // element.classList.remove('animate__backInRight',);

        //element.classList.add('animate__backOutRight');
    }

});
